import React from 'react';
import { Accordion } from 'react-bootstrap';
import { useLang } from "../../contexts/LanguageContext";

const FaqAccordion = () => {
  /* Inciar constante de traducción */
  const { t } = useLang();

  return (
    <div className="container my-4">
      <h2 className="mb-4">{t("INDEX_FAQ_TITLE")}</h2>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t("INDEX_FAQ_QUESTION1")}</Accordion.Header>
          <Accordion.Body>
          {t("INDEX_FAQ_ANSWER1")}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>{t("INDEX_FAQ_QUESTION2")}</Accordion.Header>
          <Accordion.Body>
          {t("INDEX_FAQ_ANSWER2")}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>{t("INDEX_FAQ_QUESTION3")}</Accordion.Header>
          <Accordion.Body>
          {t("INDEX_FAQ_ANSWER3")}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>{t("INDEX_FAQ_QUESTION4")}</Accordion.Header>
          <Accordion.Body>
          {t("INDEX_FAQ_ANSWER4")}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header>{t("INDEX_FAQ_QUESTION5")}</Accordion.Header>
          <Accordion.Body>
          {t("INDEX_FAQ_ANSWER5")}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default FaqAccordion;
